import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import apiInstance from '../../utils/axios';
import ProductCard from '../../components/ProductCard';

import { Link } from 'react-router-dom';

const OffersCarousel = () => {

  const [carouselData, setCarouselData] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Handle responsive breakpoint
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchCarouselData = async () => {
      try {
        // Use new Ofertas do Dia endpoint
        console.log('Fetching ofertas-do-dia data...');
        const response = await apiInstance.get('ofertas-do-dia/');
        const data = Array.isArray(response.data) ? response.data : (response.data.results || []);
        console.log('Ofertas data received:', data.length, 'items');
        if (data.length > 0) {
          console.log('First item:', data[0]);
        }
        setCarouselData(data);
      } catch (error) {
        console.error('Error fetching Ofertas do Dia:', error);
        // Fallback to old endpoint on error
        try {
          const fallbackResponse = await apiInstance.get('offers-carousel/');
          const data = Array.isArray(fallbackResponse.data) ? fallbackResponse.data : (fallbackResponse.data.results || []);
          setCarouselData(data);
        } catch (fallbackError) {
          console.error('Fallback also failed:', fallbackError);
        }
      }
    };

    fetchCarouselData();
  }, []);

  const ArrowButton = ({ direction, onClick }) => (
    <button
      onClick={onClick}
      style={{
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        [direction === 'prev' ? 'left' : 'right']: '-15px',
        background: 'white',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        border: '2px solid #f0f0f0',
        cursor: 'pointer',
        zIndex: 10,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(52, 131, 250, 0.4)';
        e.currentTarget.style.background = '#3483fa';
        e.currentTarget.style.borderColor = '#3483fa';
        e.currentTarget.querySelector('path').style.stroke = 'white';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
        e.currentTarget.style.background = 'white';
        e.currentTarget.style.borderColor = '#f0f0f0';
        e.currentTarget.querySelector('path').style.stroke = '#3483fa';
      }}
      aria-label={direction === 'prev' ? 'Anterior' : 'Siguiente'}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path 
          d={direction === 'prev' ? "M15 18L9 12L15 6" : "M9 18L15 12L9 6"} 
          stroke="#3483fa" 
          strokeWidth="2.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 6, // Show 6 cards at once
    slidesToScroll: 6, // Move 6 slides at a time
    arrows: true,
    prevArrow: <ArrowButton direction="prev" />,
    nextArrow: <ArrowButton direction="next" />,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6, // Move 6 slides at a time
          arrows: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4, // Move 4 slides at a time
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2, // Move 2 slides at a time for 2x2 grid
          arrows: false, // Hide arrows on mobile
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2, // Move 2 slides at a time for 2x2 grid
          arrows: false, // Hide arrows on mobile
          dots: true,
        },
      },
    ],
  };

  return (
    <div style={{
      maxWidth: '1200px',
      margin: '32px auto 0 auto',
      padding: '16px 32px 16px 32px',
      overflow: 'hidden',
      backgroundColor: 'white',
      borderRadius: '20px',
      boxShadow: '0 8px 32px rgba(52,131,250,0.13), 0 2px 8px rgba(0,0,0,0.10)',
      border: '1.5px solid #e0e7ff',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      position: 'relative',
      top: '-32px',
      zIndex: 2
    }}
    className="offers-carousel-container"
    onMouseEnter={(e) => {
      e.currentTarget.style.boxShadow = '0 8px 40px rgba(0,0,0,0.12)';
      e.currentTarget.style.borderColor = '#e0e7ff';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
      e.currentTarget.style.borderColor = '#f0f0f0';
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        marginBottom: '40px',
        padding: '0'
      }}>
        <div>
          <h2 style={{
            fontSize: '28px',
            fontWeight: '500',
            color: '#333',
            margin: '0 0 8px 0',
          }}>Ofertas del día</h2>
          <p style={{
            fontSize: '16px',
            color: '#666',
            margin: 0,
          }}>¡Aprovechá los mejores descuentos de hoy!</p>
        </div>
        <Link to="/products" style={{
          color: '#333',
          textDecoration: 'none',
          fontSize: '14px',
          fontWeight: '500',
          padding: '8px 0',
          borderBottom: '2px solid #333',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.target.style.borderBottomColor = '#00a650';
          e.target.style.color = '#00a650';
        }}
        onMouseLeave={(e) => {
          e.target.style.borderBottomColor = '#333';
          e.target.style.color = '#333';
        }}
        >Ver todo</Link>
      </div>

      {/* Mobile: Grid Layout (like Productos populares) */}
      {isMobile ? (
        <div className="offers-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '12px',
          padding: '0',
        }}>
          {carouselData && carouselData.slice(0, 8).map((product) => (
            <ProductCard key={product.id} product={product} variant="compact" />
          ))}
        </div>
      ) : (
        /* Desktop: Slider */
        <div style={{ 
          position: 'relative',
          width: '100%',
          margin: '0 auto',
          padding: '0'
        }}>
          <Slider {...settings}>
            {carouselData && carouselData.map((product) => (
              <div key={product.id} style={{ 
                padding: '0 4px',
              }}>
                <ProductCard 
                  product={product} 
                  variant="compact"
                />
              </div>
            ))}
          </Slider>
        </div>
      )}
      
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          /* Custom carousel styling for better spacing */
          .slick-slide {
            padding: 0 6px !important;
          }
          
          .slick-track {
            display: flex !important;
            align-items: stretch !important;
          }
          
          .slick-slide > div {
            height: 100%;
            display: flex;
            align-items: stretch;
          }

          /* Mobile Responsiveness */
          @media (max-width: 768px) {
            .offers-carousel-container {
              padding: 12px !important;
              margin: 16px 8px !important;
              border-radius: 12px !important;
              box-shadow: 0 2px 12px rgba(0,0,0,0.08) !important;
              max-width: calc(100% - 16px) !important;
            }
            
            .offers-carousel-container > div:first-child {
              margin-bottom: 16px !important;
              flex-direction: column !important;
              align-items: flex-start !important;
              gap: 8px !important;
            }
            
            .offers-carousel-container h2 {
              font-size: 18px !important;
              margin-bottom: 2px !important;
            }
            
            .offers-carousel-container p {
              font-size: 12px !important;
            }
            
            .slick-slide {
              padding: 0 4px !important;
            }
            
            .slick-slide > div {
              height: auto !important;
            }
            
            .slick-dots {
              bottom: -24px !important;
            }
            
            .slick-dots li {
              margin: 0 2px !important;
            }
            
            .slick-dots li button:before {
              font-size: 8px !important;
              color: #3483fa !important;
            }
          }
          
          @media (max-width: 480px) {
            .offers-carousel-container {
              padding: 10px !important;
              margin: 12px 6px !important;
              border-radius: 10px !important;
              max-width: calc(100% - 12px) !important;
            }
            
            .offers-carousel-container h2 {
              font-size: 16px !important;
              line-height: 1.2 !important;
            }
            
            .offers-carousel-container p {
              font-size: 11px !important;
            }
            
            .slick-slide {
              padding: 0 3px !important;
            }
            
            .slick-dots {
              bottom: -20px !important;
            }
          }
          
          /* Mobile Product Card Price Visibility */
          @media (max-width: 768px) {
            .offers-carousel-container .product-card-compact {
              min-height: 280px !important;
              height: auto !important;
            }
            
            .offers-carousel-container .product-card-compact .product-content {
              min-height: 120px !important;
              padding: 10px !important;
            }
            
            .offers-carousel-container .product-card-compact .price {
              font-size: 16px !important;
              font-weight: 700 !important;
              display: block !important;
              color: #1a1a1a !important;
              visibility: visible !important;
              opacity: 1 !important;
            }
          }
          
          @media (max-width: 480px) {
            .offers-carousel-container .product-card-compact {
              min-height: 260px !important;
            }
            
            .offers-carousel-container .product-card-compact .product-content {
              min-height: 110px !important;
              padding: 8px !important;
            }
            
            .offers-carousel-container .product-card-compact .price {
              font-size: 15px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default OffersCarousel;